/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';


export interface SeccionMenuFiltroIdDepartament10Get$Params {
  idDepartament: string;
}

export function seccionMenuFiltroIdDepartament10Get(http: HttpClient, rootUrl: string, params: SeccionMenuFiltroIdDepartament10Get$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, seccionMenuFiltroIdDepartament10Get.PATH, 'get');
  if (params) {
    rb.path('idDepartament', params.idDepartament, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

seccionMenuFiltroIdDepartament10Get.PATH = `/seccion-menu-filtro/{idDepartament}/${APP_CONSTANTS.TOP_JOBS_NUMBER}`;
